<template>
  <div>
    <Receipt
      v-if="receiptTemplate && receipts"
      :receipt-template="receiptTemplate"
      :receipts="receipts"
      :template="2"
      :print-header="true" />
  </div>
</template>

<script>
import api from '../apis'
import Receipt from 'dona2-vue-receipt'

export default {
  components: {
    Receipt
  },
  data () {
    return {
      orderId: null,
      receiptTemplate: null,
      receipts: null
    }
  },
  created () {
    this.orderId = this.$route.query.orderId

    // 取得收據資料
    api.order.printOrderReceipt(this.orderId)
      .then(response => {
        this.receipts = response.data

        this.receipts.forEach(r => {
          r.actionLabel = r.isDona ? '捐款' : '購買'
        })

        if (this.receipts.length > 0) {
          this.receipts[0].receiptAmountCovInWords = this.receipts[0].receiptAmountCovInWords + '元'

          const storeId = this.receipts[0].store.id
          api.receiptTemplate.query(storeId)
            .then(response2 => {
              if (response2.data.length > 0) {
                this.receiptTemplate = response2.data[0]
                this.receiptTemplate.receiptAmountCovInWords = this.receiptTemplate.receiptAmountCovInWords + '元'
              }

              console.log(this.receipts, this.receiptTemplate)
            })
        }
      })
  }
}
</script>

<style>
#app {
  max-width: initial !important;
  min-width: initial !important;
}
</style>
